/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Album
 */
export interface Album {
    /**
     * 
     * @type {string}
     * @memberof Album
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Album
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Album
     */
    imageId?: string;
    /**
     * 
     * @type {number}
     * @memberof Album
     */
    songCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof Album
     */
    complete: boolean;
}

/**
 * Check if a given object implements the Album interface.
 */
export function instanceOfAlbum(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "songCount" in value;
    isInstance = isInstance && "complete" in value;

    return isInstance;
}

export function AlbumFromJSON(json: any): Album {
    return AlbumFromJSONTyped(json, false);
}

export function AlbumFromJSONTyped(json: any, ignoreDiscriminator: boolean): Album {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'imageId': !exists(json, 'imageId') ? undefined : json['imageId'],
        'songCount': json['songCount'],
        'complete': json['complete'],
    };
}

export function AlbumToJSON(value?: Album | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'imageId': value.imageId,
        'songCount': value.songCount,
        'complete': value.complete,
    };
}

